import { Component, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { UserTicket, UserTicketTrip, PaymentStatus } from '../../core/userTicket';
import { TramApiService } from '../../tram-api.service';
import { ActivatedRoute } from '@angular/router';
import { TicketEmailComponent } from './ticket-email.component';
import { TicketPaymentComponent } from './ticket-payment.component';
import { TicketPassComponent } from './ticket-pass.component';
import { HttpErrorResponse } from '@angular/common/http';

enum TicketCallbackAction {
    pay = 'pay'
}

@Component({
    selector: 'ticket-display',
    templateUrl: './ticket-display.component.html',
    styleUrls: ['./ticket-display.component.scss']
})
export class TicketDisplayComponent {
    @Input() ticketId: string | UserTicket;

    @Output() ticketChange = new EventEmitter<UserTicket>();

    @ViewChild('emailModal') emailModal: TicketEmailComponent;
    @ViewChild('paymentModal') paymentModal: TicketPaymentComponent;
    @ViewChild('passModal') passModal: TicketPassComponent;

    public isLoading: boolean = false;
    public ticket: UserTicket;

    private callbackAction: TicketCallbackAction = null;

    constructor(
        private api: TramApiService,
        private toaster: ToasterService,
        activatedRoute: ActivatedRoute) {

        activatedRoute.queryParamMap.subscribe(paramMap => {
            if (paramMap.keys.length <= 0) return;

            const action = (paramMap.has('action') ? paramMap.get('action') : null);
            if (action && action in TicketCallbackAction) {
                this.callbackAction = <TicketCallbackAction>action;
            }
        });
    }

    ngOnInit() {
        this.loadTicket();
    }

    onPassModalClosed(newTrip: UserTicketTrip) {
        if (!newTrip) return;

        this.loadTicket(true);
    }

    private loadTicket(reload: boolean = false) {
        if (!this.ticketId) return;

        let ticketId;
        if (typeof this.ticketId === "string") {
            ticketId = this.ticketId;
        } else if (reload) {
            ticketId = this.ticketId.id;
        } else {
            this.onTicketLoaded(this.ticketId, reload);
            return;
        }

        this.isLoading = true;

        this.api.getTicket(ticketId)
            .then(ticket => {
                this.isLoading = false;
                this.onTicketLoaded(ticket, reload);
            })
            .catch(err => this.handleError(err));
    }

    private onTicketLoaded(ticket: UserTicket, reload: boolean = false): void {
        this.ticket = ticket;

        if (!reload && this.callbackAction) {
            this.processCallbackAction();
        }
        if (reload) {
            this.ticketChange.emit(ticket);
        }
    }

    private processCallbackAction() {
        if (this.callbackAction === TicketCallbackAction.pay && this.ticket.payment.status !== PaymentStatus.successful) {
            this.paymentModal.open();
        }
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/ticket/ticket-display.component.ts